import {
  ICardSettings,
  TApplePayService,
  TBlikService,
  TCardService,
  TIdealService,
  TMultibancoService,
  TGooglePayService,
  TMbwayService,
  TSwishservice,
} from './model';
import {
  IBancontactSettings,
  TBancontactMobileService,
  TBancontactService,
  TTMobilePayService,
  TTwintService,
} from './model/adyenService';

export const PRODUCTION_ENVIRONMENT_DOMAIN_NAME: string = 'production';
export const PRODUCTION_ENVIRONMENT_ADYEN_NAME: string = 'live';
export const TEST_ENVIRONMENT_ADYEN_NAME: string = 'test';

export const CARD_SERVICE: TCardService = 'card';
export const BLIK_SERVICE: TBlikService = 'blik';
export const IDEAL_SERVICE: TIdealService = 'ideal';
export const TWINT_SERVICE: TTwintService = 'twint';
export const MULTIBANCO_SERVICE: TMultibancoService = 'multibanco';
export const MBWAY_SERVICE: TMbwayService = 'mbway';
export const APPLE_PAY_SERVICE: TApplePayService = 'applepay';
export const GOOGLE_PAY_SERVICE: TGooglePayService = 'googlepay';
export const BANCONTACT_SERVICE: TBancontactService = 'bcmc';
export const BANCONTACT_MOBILE_SERVICE: TBancontactMobileService = 'bcmc_mobile';
export const MOBILE_PAY_SERVICE: TTMobilePayService = 'mobilepay';
export const SWISH_SERVICE: TSwishservice = 'swish';

export const CARD_SERVICE_SETTINGS: ICardSettings = { holderNameRequired: true, hasHolderName: true, autoFocus: true };

export const BANCONTACT_SERVICE_SETTINGS: IBancontactSettings = {
  holderNameRequired: true,
  hasHolderName: true,
  autoFocus: true,
};

export const THREE_DS_ONE_PARAM_PA_REQ: string = 'PaReq';
export const THREE_DS_ONE_PARAM_MD: string = 'MD';
export const THREE_DS_ONE_PARAM_TERM_URL: string = 'TermUrl';

export const MASTER_CARD_IMG_URL = '/images/payment/mc.png';
export const VISA_CARD_IMG_URL = '/images/payment/visa.png';
export const BLIK_IMAGE_URL = '/images/payment/blik.png';
export const IDEAL_IMAGE_URL = '/images/payment/ideal.png';
export const TWINT_IMAGE_URL = '/images/payment/twint.png';
export const MBWAY_IMAGE_URL = '/images/payment/mbway.png';
export const BANCONTACT_IMAGE_URL = '/images/payment/bancontact.png';
export const MOBILE_PAY_IMAGE_URL = '/images/payment/mobilepay.png';
export const SWISH_IMAGE_URL = '/images/payment/swish.png';

export const MAST_CARD_METHOD_NAME = 'MasterCard';
export const VISA_CARD_METHOD_NAME = 'VISA';
export const IDEAL_METHOD_NAME = 'iDeal';
export const TWINT_METHOD_NAME = 'Twint';
export const BLIK_METHOD_NAME = 'Blik';
export const MBWAY_METHOD_NAME = 'MB WAY';
export const BANCONTACT_METHOD_NAME = 'Bancontact';
export const MOBILE_PAY_METHOD_NAME = 'MobilePay';
export const SWISH_METHOD_NAME = 'Swish';

export const MC_BRAND = 'mc';
export const VISA_BRAND = 'visa';
export const BANCONTACT_BRAND = 'bcmc';
export type AdyenEnvironment = 'test' | 'live' | 'live-us' | 'live-au' | 'live-apse' | 'live-in';
